<template>
  <div
    class="hbn-container"
    id="userArchive"
    ref="rootRef"
    v-loading="exporting"
    element-loading-text="导出中，请稍候..."
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="search-form" ref="searchRef">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form label-width="90px" label-position="right" size="mini">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="用户名称">
                  <el-input
                    v-model="PageQuery.queryModel.userName"
                    placeholder="用户名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    v-model="PageQuery.queryModel.phone"
                    placeholder="手机号"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="首页专区">
                  <el-cascader
                    v-model="homePageZoneId"
                    :options="homePageZoneOptions"
                    :props="homePageZoneProps"
                    placeholder="请选择首页专区"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="省市区">
                  <el-select
                    v-model="selectedProvinceId"
                    placeholder="省"
                    clearable
                    style="width: 31%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    />
                  </el-select>
                  <el-select
                    v-model="selectedCityId"
                    placeholder="市"
                    clearable
                    style="width: 31%; margin: 0 3.5%"
                    :disabled="!selectedProvinceId"
                    @change="handleCityChange"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    />
                  </el-select>
                  <el-select
                    v-model="selectedRegionId"
                    placeholder="区"
                    clearable
                    style="width: 31%"
                    :disabled="!selectedCityId"
                    @change="handleRegionChange"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位名称">
                  <el-input
                    v-model="PageQuery.queryModel.UnitName"
                    placeholder="单位名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="creationTimeRange"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    style="width: 100%"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="searchData">
              查找
            </el-button>
            <el-button
              size="mini"
              type="primary"
              :disabled="exporting"
              @click="exportArchive"
            >
              导出
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="custom-table-layer">
        <div class="table-box">
          <vxe-table
            :data="DataList"
            round
            border
            :height="tableHeight"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>
            <template v-for="(item, key) in UserList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :formatter="formatterData"
                :class-name="JSON.stringify(item)"
              />
            </template>
          </vxe-table>
        </div>

        <div class="pagination" ref="pagerRef">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          />
          <div class="total-count-text">共 {{ total }} 条记录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserList } from "@/assets/apiData/Company/UserList";
import { GetDataUserListByPageQuery, ExportUserArchiveZip } from "@api/Company/ApiUser";
import { getHomePageZones } from "@api/Basic";
import { apiDefRegion } from "@api/dministrativeDivisions";
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          userName: "",
          phone: "",
          homePageCategoryId: null,
          provinceName: "",
          cityName: "",
          regionName: "",
          UnitName: "",
          creationTimeStart: "",
          creationTimeEnd: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      UserList: [],
      DataList: [],
      homePageZoneId: [],
      homePageZoneOptions: [],
      homePageZoneProps: {
        expandTrigger: "hover",
        value: "id",
        label: "name",
        children: "categories",
      },
      provinceList: [],
      cityList: [],
      regionList: [],
      selectedProvinceId: "",
      selectedCityId: "",
      selectedRegionId: "",
      creationTimeRange: [],
      tableHeight: 430,
      exporting: false,
    };
  },
  created() {
    this.UserList = UserList;
    this.getHomePageZoneList();
    this.getProvinceList();
    this.GetData();
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const minHeight = 260;
        const rootHeight =
          this.$refs.rootRef?.getBoundingClientRect?.().height || window.innerHeight;
        const searchHeight =
          this.$refs.searchRef?.getBoundingClientRect?.().height || 0;
        const pagerHeight =
          this.$refs.pagerRef?.getBoundingClientRect?.().height || 0;
        const reserved = 42;
        const calcHeight = rootHeight - searchHeight - pagerHeight - reserved;
        this.tableHeight = calcHeight > minHeight ? calcHeight : minHeight;
      });
    },
    formatterData({ cellValue, column }) {
      const head = JSON.parse(column.className);
      switch (head.format) {
        case "datetime":
          return dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
        case "status":
          return cellValue == "0" ? "待审核" : cellValue == "1" ? "启用" : "禁用";
        case "registerType":
          return ["平台新增", "小程序注册", "平台导入"][cellValue];
        default:
          return cellValue;
      }
    },
    getHomePageZoneList() {
      getHomePageZones().then((res) => {
        this.homePageZoneOptions = res.map((zone) => ({
          id: zone.id,
          name: zone.name,
          categories: zone.categories.map((category) => ({
            id: category.id,
            name: category.categoryName,
            homePageId: category.homePageId,
          })),
        }));
      });
    },
    getProvinceList() {
      apiDefRegion(2).then((res) => {
        this.provinceList = res?.entities || [];
      });
    },
    async handleProvinceChange(val) {
      const current = this.provinceList.find((item) => item.id === val);
      this.PageQuery.queryModel.provinceName = current ? current.areaName : "";
      this.selectedCityId = "";
      this.selectedRegionId = "";
      this.PageQuery.queryModel.cityName = "";
      this.PageQuery.queryModel.regionName = "";
      this.regionList = [];
      if (!val || !current) {
        this.cityList = [];
        return;
      }
      const { entities = [] } = await apiDefRegion(3);
      this.cityList = entities.filter((item) => item.parentCode === current.code);
    },
    async handleCityChange(val) {
      const current = this.cityList.find((item) => item.id === val);
      this.PageQuery.queryModel.cityName = current ? current.areaName : "";
      this.selectedRegionId = "";
      this.PageQuery.queryModel.regionName = "";
      if (!val || !current) {
        this.regionList = [];
        return;
      }
      const { entities = [] } = await apiDefRegion(4);
      this.regionList = entities.filter((item) => item.parentCode === current.code);
    },
    handleRegionChange(val) {
      const current = this.regionList.find((item) => item.id === val);
      this.PageQuery.queryModel.regionName = current ? current.areaName : "";
    },
    buildQueryModel() {
      const homePageCategoryId =
        this.homePageZoneId && this.homePageZoneId.length > 0
          ? this.homePageZoneId[this.homePageZoneId.length - 1]
          : null;
      const creationTimeStart =
        this.creationTimeRange && this.creationTimeRange.length > 0
          ? this.creationTimeRange[0]
          : "";
      const creationTimeEnd =
        this.creationTimeRange && this.creationTimeRange.length > 1
          ? this.creationTimeRange[1]
          : "";
      this.PageQuery.queryModel = {
        ...this.PageQuery.queryModel,
        homePageCategoryId,
        creationTimeStart,
        creationTimeEnd,
      };
    },
    searchData() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    async exportArchive() {
      if (this.exporting) {
        return;
      }
      const hasUserName = !!(this.PageQuery?.queryModel?.userName || "").trim();
      const hasPhone = !!(this.PageQuery?.queryModel?.phone || "").trim();
      const hasProvince = !!(this.PageQuery?.queryModel?.provinceName || "").trim();
      const hasCity = !!(this.PageQuery?.queryModel?.cityName || "").trim();
      const hasRegion = !!(this.PageQuery?.queryModel?.regionName || "").trim();
      const hasUnitName = !!(this.PageQuery?.queryModel?.unitName || "").trim();
      const hasCreationTime =
        !!(this.creationTimeRange && this.creationTimeRange.length > 0);
      const hasHomePageZone = !!(this.homePageZoneId && this.homePageZoneId.length > 0);
      if (
        !hasUserName &&
        !hasPhone &&
        !hasProvince &&
        !hasCity &&
        !hasRegion &&
        !hasUnitName &&
        !hasCreationTime &&
        !hasHomePageZone
      ) {
        this.$message?.warning?.(
          "请至少填写一个查询条件（用户名称、手机号、省市区、单位名称、创建时间或首页专区）"
        );
        return;
      }
      this.buildQueryModel();
      this.exporting = true;
      try {
        await ExportUserArchiveZip(this.PageQuery.queryModel);
      } catch (error) {
        this.$message?.error?.("导出失败，请稍后重试");
      } finally {
        this.exporting = false;
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1;
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    GetData() {
      this.buildQueryModel();
      GetDataUserListByPageQuery(JSON.stringify(this.PageQuery)).then((data) => {
        this.DataList = data.entities;
        this.total = data.totalCount;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#userArchive {
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
}

.hbn-table-screen {
  flex: 1;
  min-height: 0;
}

.custom-table-layer {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-box {
  flex: 1;
  min-height: 0;
  margin-bottom: 13px;
}

.pagination {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.total-count-text {
  font-size: 12px;
  color: #606266;
  white-space: nowrap;
}

::v-deep(.el-loading-mask .el-loading-spinner .el-icon-loading) {
  color: #ffffff;
  font-size: 26px;
}

::v-deep(.el-loading-mask .el-loading-spinner .el-loading-text) {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}
</style>
